import * as React from 'react';
import * as cn from 'classnames';

import { BulletListItem } from '../../BulletListItem';

import * as styles from './styles.css';

interface IProps {
  className?: string;
  content: string[];
}

export const ContentList: React.FC<IProps> = ({ className, content }) => {
  const halfIndex = Math.floor(content.length / 2);
  const contentFirstHalf = content.slice(0, halfIndex);
  const contentSecondHalf = content.slice(halfIndex, content.length);

  return (
    <div className={cn(styles['container'], className)}>
      <div className={styles['col']}>
        {contentFirstHalf.map((contentItem, i) => {
          return (
            <div className={styles['bullet-item-wrapper']} key={i}>
              <BulletListItem lineHeight={22}>{contentItem}</BulletListItem>
            </div>
          );
        })}
      </div>
      <div className={styles['col']}>
        {contentSecondHalf.map((contentItem, i) => {
          return (
            <div className={styles['bullet-item-wrapper']} key={i}>
              <BulletListItem lineHeight={22}>{contentItem}</BulletListItem>
            </div>
          );
        })}
      </div>
    </div>
  );
};

ContentList.displayName = 'ContentList';
